import React, { FC } from 'react';
import ReactModal from 'react-modal';
import classNames from 'classnames';

const defaultProps = {
  className: '',
  overlayClassName: '',
  shouldCloseOnOverlayClick: true,
};

type Props = {
  onRequestClose: () => void;
  isOpen: boolean;
  className?: string;
  overlayClassName?: string;
  shouldCloseOnOverlayClick?: boolean;
};

export const Modal: FC<Props> = (props) => {
  const modalProps = {
    ...props,
    className: classNames(props.className, 'react-modal'),
    overlayClassName: classNames(
      props.overlayClassName,
      'react-modal__overlay',
    ),
  };

  return (
    <ReactModal {...modalProps} ariaHideApp={false}>
      {props.children}
    </ReactModal>
  );
};

Modal.defaultProps = defaultProps;
